module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select car")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Audi")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("BMW")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Citroen")]), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Ford")]), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Honda")]), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Jaguar")]), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Land Rover")]), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Mercedes")]), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Mini")]), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Nissan")]), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Toyota")]), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Volvo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d16ec96","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relation/inputCustom.vue
// module id = 1482
// module chunks = 0